import React from 'react'

export const MessageErrorUnstyled = props => (
  <div className={props.className}>{props.message}</div>
)
